import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Version1Module } from "./version1/version1.module";
import { Version5Module } from "./version5/version5.module";
import { TrainingModule } from "./training/training.module";
import {EvaluadorModule} from "./evaluador/evaluador.module";
//import { EvaluadorComponent } from './evaluador/evaluador.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    Version1Module,
    Version5Module,
    TrainingModule,
    EvaluadorModule
  ]
})
export class CultureauditModule { }
